import _objectSpread from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.join.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Helpers
import { mapState } from 'vuex';
export default {
  props: {
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      header: null,
      logoSrc: null,
      product: null,
      scrollY: null
    };
  },
  fetch: function fetch() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var $swell, baseProduct, product;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              $swell = _this.$swell; // Fetch item that has been recently added to the cart

              if (!_this.addedItem) {
                _context.next = 9;
                break;
              }

              _context.next = 4;
              return $swell.products.get(_this.addedItem.productId);

            case 4:
              baseProduct = _context.sent;
              _context.next = 7;
              return $swell.products.variation(baseProduct, _this.addedItem.options);

            case 7:
              product = _context.sent;
              _this.product = product;

            case 9:
              _context.next = 11;
              return $swell.settings.get('header');

            case 11:
              _this.header = _context.sent;
              _context.next = 14;
              return $swell.settings.get('header.logo.file.url');

            case 14:
              _this.logoSrc = _context.sent;

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: _objectSpread(_objectSpread({}, mapState(['cart', 'cartIsUpdating', 'currency', 'addedItem', 'headerIsVisible', 'headerHeight', 'currency'])), {}, {
    options: function options() {
      if (!this.addedItem) return;
      var options = Object.values(this.addedItem.options);
      return options.join(', ');
    },
    headerHeightOffset: function headerHeightOffset() {
      // Set initial height before scroll initiates
      if (this.scrollY === null) {
        if (!this.headerIsVisible) return 0;
        if (this.headerIsVisible) return this.headerHeight;
      }

      if (!this.headerIsVisible) return 0;

      if (this.scrollY < this.headerHeight) {
        return this.headerHeight - (this.headerHeight - this.scrollY);
      }

      return this.headerHeight;
    }
  }),
  watch: {
    // If no added item in notification, hide recently added product
    addedItem: function addedItem(item) {
      if (!item) this.product = null;
    }
  },
  mounted: function mounted() {
    this.onScroll();
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll: function onScroll() {
      this.scrollY = window.scrollY;
    },
    openCart: function openCart() {
      // Open cart and close notification
      this.$store.commit('setState', {
        key: 'cartIsActive',
        value: true
      });
      this.$store.commit('setState', {
        key: 'notification',
        value: null
      });
    }
  }
};